import styled from "styled-components";
import { MDBNavbarLink, MDBNavbarItem, MDBContainer } from "mdb-react-ui-kit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrophy,
  faLock,
  faMapMarker,
  faLightbulb,
  faGift,
  faCalendar,
  faClock,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import ChallengeTypeIcon from "../organize/ChallengeTypeIcon";
import { ChallengeNavbar } from "../organize/Challenge.styles";
import { useChallengeQuery } from "./Library.state";

const LibraryChallengeNavbar = styled(ChallengeNavbar)`
  margin-top: 2rem;
  margin-bottom: 2rem;

  ul {
    display: flex;
    margin: 0;
    padding: 0;
  }
`;

const LibraryChallengeNav = ({ id, section, setSection }) => {
  const {
    hide_answers,
    hints,
    latitude,
    reward_title,
    reward_description,
    starts_at,
    ends_at,
    task_type,
    timer,
    unlock_by_location_radius,
    unlock_by_task_id,
  } = useChallengeQuery(id);

  return (
    <LibraryChallengeNavbar expand="lg">
      <MDBContainer fluid>
        <ul className="list-unstyled">
          <MDBNavbarItem>
            <MDBNavbarLink
              active={section === "type"}
              onClick={() => setSection("type")}
            >
              Type <ChallengeTypeIcon task_type={task_type} />
            </MDBNavbarLink>
          </MDBNavbarItem>
          <MDBNavbarItem>
            <MDBNavbarLink
              active={section === "points"}
              onClick={() => setSection("points")}
            >
              Points <FontAwesomeIcon icon={faTrophy} />
            </MDBNavbarLink>
          </MDBNavbarItem>
          {(!!unlock_by_task_id || !!unlock_by_location_radius) && (
            <MDBNavbarItem>
              <MDBNavbarLink
                active={section === "locks"}
                onClick={() => setSection("locks")}
              >
                Locks <FontAwesomeIcon icon={faLock} />
              </MDBNavbarLink>
            </MDBNavbarItem>
          )}
          {!!latitude && (
            <MDBNavbarItem>
              <MDBNavbarLink
                active={section === "location"}
                onClick={() => setSection("location")}
              >
                Location <FontAwesomeIcon icon={faMapMarker} />
              </MDBNavbarLink>
            </MDBNavbarItem>
          )}
          {!!hints && (
            <MDBNavbarItem>
              <MDBNavbarLink
                active={section === "hints"}
                onClick={() => setSection("hints")}
              >
                Hints <FontAwesomeIcon icon={faLightbulb} />
              </MDBNavbarLink>
            </MDBNavbarItem>
          )}
          {(!!reward_title || !!reward_description) && (
            <MDBNavbarItem>
              <MDBNavbarLink
                active={section === "rewards"}
                onClick={() => setSection("rewards")}
              >
                Rewards and Clues <FontAwesomeIcon icon={faGift} />
              </MDBNavbarLink>
            </MDBNavbarItem>
          )}
          {(starts_at || ends_at) && (
            <MDBNavbarItem>
              <MDBNavbarLink
                active={section === "timing"}
                onClick={() => setSection("timing")}
              >
                Timing <FontAwesomeIcon icon={faCalendar} />
              </MDBNavbarLink>
            </MDBNavbarItem>
          )}
          {!!timer && (
            <MDBNavbarItem>
              <MDBNavbarLink
                active={section === "timers"}
                onClick={() => setSection("timers")}
              >
                Timers <FontAwesomeIcon icon={faClock} />
              </MDBNavbarLink>
            </MDBNavbarItem>
          )}
          {!!hide_answers && (
            <MDBNavbarItem>
              <MDBNavbarLink
                active={section === "visibility"}
                onClick={() => setSection("visibility")}
              >
                Visibility <FontAwesomeIcon icon={faEye} />
              </MDBNavbarLink>
            </MDBNavbarItem>
          )}
        </ul>
      </MDBContainer>
    </LibraryChallengeNavbar>
  );
};

export default LibraryChallengeNav;
